// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export default defineNuxtPlugin(() => {
  return {
    provide: {
      bootstrap: {
        Collapse: import('bootstrap').then(bootstrap => bootstrap.Collapse)
      }
    }
  }
})
